module.exports = __webpack_public_path__ + "static/img/180119.ef4dc99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/events/180119.png
// module id = 5PPT
// module chunks = 0